// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
	Button 
} from "@mantine/core";


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
	useAuth 
} from "../../hooks/useAuth";


// Exports
export const LoginButton = ({ outline }: { outline?: boolean }) => {
	const { login, logout, authState } = useAuth();
	const isLoggedIn = authState && authState.isAuthenticated;

	return (
		<>
			<Button
				variant={outline ? "outline" : "filled"}
				style={{ backgroundColor: outline ? "white" : undefined }}
				onClick={() => {
					if (isLoggedIn) {
						logout();
					} else {
						login();
					}
				}}
			>
				{isLoggedIn ? "Logout" : " Login"}
			</Button>
		</>
	);
};